import groupBy from 'lodash/groupBy';
import map from 'lodash/map';
import maxBy from 'lodash/maxBy';

import { IAutoThirdPartyDataOrders } from '../../interfaces';

export default function getLatestDataOrders(
  orders: IAutoThirdPartyDataOrders[]
) {
  const ordersByDataType = groupBy(orders, 'data_type');
  const latestOrders = map(ordersByDataType, (orders) =>
    maxBy(orders, (order) => order.order_date || 0)
  );
  return latestOrders;
}
